/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubsystemRequestDto
 */
export interface UpdateSubsystemRequestDto {
    /**
     * Unique code for the subsystem
     * @type {string}
     * @memberof UpdateSubsystemRequestDto
     */
    code?: string;
    /**
     * Name of the subsystem
     * @type {string}
     * @memberof UpdateSubsystemRequestDto
     */
    name?: string;
    /**
     * Description of the subsystem
     * @type {string}
     * @memberof UpdateSubsystemRequestDto
     */
    description?: string;
    /**
     * JSON schema for metadata validation
     * @type {{ [key: string]: any; }}
     * @memberof UpdateSubsystemRequestDto
     */
    metadataSchema?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the UpdateSubsystemRequestDto interface.
 */
export function instanceOfUpdateSubsystemRequestDto(value: object): value is UpdateSubsystemRequestDto {
    return true;
}

export function UpdateSubsystemRequestDtoFromJSON(json: any): UpdateSubsystemRequestDto {
    return UpdateSubsystemRequestDtoFromJSONTyped(json, false);
}

export function UpdateSubsystemRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubsystemRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
    };
}

export function UpdateSubsystemRequestDtoToJSON(json: any): UpdateSubsystemRequestDto {
    return UpdateSubsystemRequestDtoToJSONTyped(json, false);
}

export function UpdateSubsystemRequestDtoToJSONTyped(value?: UpdateSubsystemRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
    };
}

